import { useEffect, useRef, useState } from 'react';
import { createI18nContext } from '@aviv-unified-frontend/runtime/i18n';

import type { TLocalesTags } from '@/frontend/src/types/locale';

const useI18nContext = (language: TLocalesTags) => {
    const [loading, setLoading] = useState(true);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const context = useRef<any>(undefined);

    useEffect(() => {
        context.current = createI18nContext({
            languageTag: language,
        });

        setLoading(false);
    }, [language]);

    return { loading, I18N_CONTEXT: context.current };
};

export default useI18nContext;
